module.exports = __webpack_public_path__ + "img/img01.d27ebd3f.png";